module.exports = __webpack_public_path__ + "static/fabrica-slide2-a0c2441042849ee8e76211d328e67565.jpg";